import { ContainerProps, Container } from "@mui/material";

interface AssignmentOverviewContainerProps extends ContainerProps {};

function AssignmentOverviewContainer(props: AssignmentOverviewContainerProps) {
    return <Container {...props} sx={{height: "100%"}}/>
};

export default AssignmentOverviewContainer;